// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var InviteRejectionReason = function (x) {
    return x;
};
var tsBridgeInviteRejectionRe = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("InviteRejectionReason")("__brandInviteRejectionReason"));
    }
};
var writeInviteRejectionReason = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showInviteRejectionReason = Data_Show.showString;
var readInviteRejectionReason = Simple_JSON.readString;
var ordInviteRejectionReason = Data_Ord.ordString;
var newtypeInviteRejectionReason = {
    Coercible0: function () {
        return undefined;
    }
};
var makeInviteRejectionReason = InviteRejectionReason;
var eqInviteRejectionReason = Data_Eq.eqString;
export {
    InviteRejectionReason,
    makeInviteRejectionReason,
    unwrap,
    newtypeInviteRejectionReason,
    eqInviteRejectionReason,
    ordInviteRejectionReason,
    showInviteRejectionReason,
    readInviteRejectionReason,
    writeInviteRejectionReason,
    tsBridgeInviteRejectionRe
};
//# sourceMappingURL=index.js.map
